"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PetsService = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Api = _interopRequireDefault(require("../Api"));
var _excluded = ["token"],
  _excluded2 = ["token", "id"],
  _excluded3 = ["token", "id"],
  _excluded4 = ["token"],
  _excluded5 = ["token"],
  _excluded6 = ["token"],
  _excluded7 = ["token", "id"],
  _excluded8 = ["token", "id"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var PetsService = exports.PetsService = /*#__PURE__*/(0, _createClass2["default"])(function PetsService() {
  (0, _classCallCheck2["default"])(this, PetsService);
});
(0, _defineProperty2["default"])(PetsService, "list", function (_ref) {
  var token = _ref.token,
    params = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return _Api["default"].withAuth(token).get('/pet', {
    params: params
  });
});
(0, _defineProperty2["default"])(PetsService, "delete", function (_ref2) {
  var token = _ref2.token,
    id = _ref2.id,
    params = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  return _Api["default"].withAuth(token)["delete"]("/pet/".concat(id), {
    params: params
  });
});
(0, _defineProperty2["default"])(PetsService, "deleteType", function (_ref3) {
  var token = _ref3.token,
    id = _ref3.id,
    params = (0, _objectWithoutProperties2["default"])(_ref3, _excluded3);
  return _Api["default"].withAuth(token)["delete"]("/pet/type/".concat(id), {
    params: params
  });
});
(0, _defineProperty2["default"])(PetsService, "create", function (_ref4) {
  var token = _ref4.token,
    params = (0, _objectWithoutProperties2["default"])(_ref4, _excluded4);
  return _Api["default"].withAuth(token).post('/pet', _objectSpread({}, params));
});
(0, _defineProperty2["default"])(PetsService, "listPetTypes", function (_ref5) {
  var token = _ref5.token,
    params = (0, _objectWithoutProperties2["default"])(_ref5, _excluded5);
  return _Api["default"].withAuth(token).get('/pet/type', {
    params: params
  });
});
(0, _defineProperty2["default"])(PetsService, "createPetType", function (_ref6) {
  var token = _ref6.token,
    params = (0, _objectWithoutProperties2["default"])(_ref6, _excluded6);
  return _Api["default"].withAuth(token).post('/pet/type', _objectSpread({}, params));
});
(0, _defineProperty2["default"])(PetsService, "editPetType", function (_ref7) {
  var token = _ref7.token,
    id = _ref7.id,
    params = (0, _objectWithoutProperties2["default"])(_ref7, _excluded7);
  return _Api["default"].withAuth(token).patch("/pet/type/".concat(id), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(PetsService, "editPet", function (_ref8) {
  var token = _ref8.token,
    id = _ref8.id,
    params = (0, _objectWithoutProperties2["default"])(_ref8, _excluded8);
  return _Api["default"].withAuth(token).patch("/pet/".concat(id), _objectSpread({}, params));
});